import { useEffect, useState } from 'react';
import { Input } from '../input';

// Numeric text input that exposes the value as a string so it can flow
// directly into Zod schemas backed by `numeric` SQL columns (e.g.
// `defaultPricing.create`'s `numericInput` regex `^-?\d+(\.\d+)?$`). The
// internal text state lets the user type partial values like "12." without
// the parent's `value` flipping between strings during entry.
export type MoneyInputProps = {
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  placeholder?: string;
  disabled?: boolean;
  id?: string;
  trailingIcon?: React.ReactNode;
};

const isAcceptable = (text: string): boolean =>
  text === '' || /^-?\d*\.?\d*$/.test(text);

export const MoneyInput = ({
  value,
  onChange,
  onBlur,
  placeholder,
  disabled,
  id,
  trailingIcon,
}: MoneyInputProps) => {
  const [text, setText] = useState(value);

  useEffect(() => {
    setText(value);
  }, [value]);

  return (
    <Input
      disabled={disabled}
      id={id}
      inputMode="decimal"
      onBlur={onBlur}
      onChange={(event) => {
        const next = event.target.value;
        if (!isAcceptable(next)) return;
        setText(next);
        onChange(next);
      }}
      placeholder={placeholder}
      trailingIcon={trailingIcon}
      type="text"
      value={text}
    />
  );
};
